module.exports = {
  message: {
    userlogin: 'Login',
    steemAccoutPlaceHolder: 'Input Your Steem Account',
    login: 'Login',
    loging:"Login...",
    delegatemine: 'Mining by Delegation',
    spbalance: 'SP Balance',
    yourspdelegate: 'Delegated SP',
    cancel: "Cancel",
    confirm: "Confirm",

    sptotaldelegate: 'Total Delegated',
    totalpnut: 'Total PNUT',
    apy: 'APY',
    pnutprofits: 'Your Earned PNUT',
    withdraw: 'Harvest',
    balance: 'Balance',
    approveContract:"Approve Contract",
    max:"Max",
    confirmconvert: 'Confirm Conversion',
    servicecharge: 'Transaction Fee',
    delegatecharge: 'Delegation Fee',
    atleastcharge: 'least charge',
    convertrate: 'Conversion Ratio',
    logout: 'Logout',
    confirmdelegate: 'Confirm Delegation',
    delegatedsp: 'Delegated SP',
    steembalance: 'STEEM Balance',
    sbdbalance: 'SBD Balance',
    tronbalance: 'Tron Balance',
    tsteembalance: 'TSTEEM Balance',
    tsbdbalance: 'TSBD Balance',
    pnutbalance: 'PNUT Balance',
    input: 'Input',
    tips: 'Tips',

    setting: 'Setting',
    admin:'Admin',
    whitePaper: 'White Paper',
    nps: 'Nutbox Proposal System',
    userBook: 'User Handbook',
    questions: 'Questions',
    contract: 'Contract',
    swap: 'Swap',
    tools: 'Tools',
    contact: 'Contact',
    docs: 'Docs',
    discord: 'Discord',
    about: 'About',
    blog: 'Blog',
    changeSteemNode: 'Steem Node(Option)',
    contractAddr: 'Contract Address',

    dashboard: "Dashboard",
    contributions: "My contributions",
    
    language: 'Language',
    zh: '中文',
    en: 'English',
    kr: '한국어',
    my: 'Malaysia',
    tr: 'Türkçe',
    es: 'Español',
    jp: '日本語'
  },
  wallet: {
    wallet: 'Wallet',
    swap: 'Cross chain transfer',
    connectSteem:"Connect to Steem Keychain",
    connectTron:"Connect to TronLink",
    swapSubTitle:"The fast and secure way to bring cross-chain assets to Tron chain.",
    install:"Install",
    transfer:"Transfer",
    asset: "Asset",
    nomination: "Validator Nomination",
    contribution: "Crowdloan Contribution",
    balance: "Balance",
    bond: "Bond",
    unBond: "Unbond",
    redeem: "Redeem",
    bindAmount: "Bond amount",
    inputAmount: 'Please input amount',
    receiveAddress: 'Send to address',
    transferAmount: 'Transfer amount',
    unbindAmount: 'Unbond amount'
  },
  admin: {
    admin: "管理员"
  },
  cs: {
    crowdstaking: "Crowdstaking",
    community:"Commnunity",
    nominate: "Nominate",
    nominated: "Nominated",
    inputBondAmount: "Please Input ",
    bond: "Bond",
    available: "Available",
    bondAndNominate: " Bond & Nominate",
    cancel: "cancel",
    bondInfo1: "Please keep a small amount for the subsequent fee",
    bondInfo2: "It is recommended to bind at least {min} {symbol}",
    bondInfo3: "You need to wait {days} days after unbond",
    confirm: "Confirm",
    cancelValidorsInfo:"Please cancel at least {n} validators before this nominate operation"
},
validator: {
    validator: 'Validators',
    commission: "Commission",
    otherStake: "OtherStake",
    ownStake: "OwnStake",
    waiting: "Waiting"
},
date: {
  year: ' year ',
  month: ' mons ',
  day: ' days ',
  hour: ' hrs ',
  min: ' mins ',
  sec: ' sec '
},
dashboard: {
  export: "Export",
  nominators: "Nominators"
},
cl:{
  crowdloan: 'Crowdloan',
  community: "Community",
  contribute: "Contribute",
  withdraw: "Withdraw",
  youWillWithdraw: "You Would Withdraw",
  confirm: "Comfirm & sign",
  amount: "Amount",
  inputAmount: "Staking amount",
  nominator: "Nominator",
  inputNominator: "Your Nominator's address",
  optional: "(optional)",
  completed: "Completed",
  leasePeriod: "Lease Period",
  countDown: "Countdown",
  rewards: 'Rewards',
  auctionPlan: "Crowdloan Reward",
  auctionInfo: "Crowdloan Detail",
  joinAuction: "Join Crowdloan",
  raised: "Raised",
  fund: "Fund",
  progress: 'Progress',
  contributors:"Contributors",
  contributed: "My Contribution",
  myBalance: "Balance of {token}",
  Active: "Active",
  Retired: "Retired",
  Completed: "Completed",
  chain: "Chain",
  trieIndex: "TrieIndex",
  contributeAmount: 'Contribute amount',
  contributeTime: 'Contribute time'
},
transaction: {
  broadcasting: "Transaction Is Broadcasting.",
  inBlock: "Transaction included at blockHash.",
  contributeOk: "Contribution Success!",
  withdrawOk: "Withdraw Success!",
  nominateOk: "Nominate Success!",
  transactionOk:"Transaction Success!",
},
  stake: {
    stake: 'Staking Mining',
    creaseDelegation: "Delegate",
    increaseDelegation: "Undelegate",
    getSp: "Get SP",
    get: "Get",
  },
  farm: {
    farm: 'Farming',
    stake: "Stake",
    unStake: "Unstake",
    tsp: {
      tspMine: 'TSP Stake',
      yourTspAmount: 'TSP Staked',
      balanceOfTsp: 'TSP Balance',
      tspMinlingFee: 'Fee',
      totalDepositTsp: 'Total Deposited',
      confirmDeposit: 'Confirm',
      addTspDeposit: 'Stake',
      minusTspDeposit: 'Unstake',
      notEnoughFee: 'Insufficient fee',
    },
    tsteem: {
      tsteemMine: 'TSTEEM Stake',
      yourTsteemAmount: 'TSTEEM Staked',
      balanceOfTsteem: 'TSTEEM Balance',
      tsteemMinlingFee: 'Fee',
      totalDepositTsteem: 'Total Deposited',
      confirmDeposit: 'Confirm',
      addTsteemDeposit: 'Stake',
      minusTsteemDeposit: 'Unstake',
      notEnoughFee: 'Insufficient fee',
    },
    tspLp: {
      tspLPBalance: 'S-TSP-TRX Balance',
      yourTSPLPAmount: 'S-TSP-TRX Staked',
      totalDepositTspLP:"Total Deposited",
      totalTSP: 'Total TSP',
    },
    pnutLp: {
      pnutLPBalance: 'S-PNUT-TRX Balance',
      yourPNUTLPAmount: 'S-PNUT-TRX Staked',
      totalDepositPnutLP:'Total Deposited'
    }
  },
  liquidStaking: {
    liquidStaking: 'Liquid Staking',
    title: "TSP Stake & Redeem",
    tsp: {
      tspIsCirculatingSP: 'TSP is the equivalent of SP, TSP can enjoy the same staking reward of SP, and can be traded as well.',
      tsptosteemintro: 'The STEEM will be returned to your Steem account in around 33~40 days after TSP is claimed to be redeemed.'
    }
  },
  tip: {
    loading: "Loading, please wait",
    connectingPolkadot: "Connecting Polkadot network",
    noAuction : "No ongoing auction",
    noProject:"No ongoing project",
    noNominations: "No nominated validators",
    noContribuitons: "No contribution records",
    noCrowdloan: "No ongoing crowdloan",
    noStakingProject: "No validators",
    tokenSafeTip: "Your asset would be locked into {symbol} official crowdloan pallet directly, not any accounts of Nutobx.",
    belowMinContribution:"Input is less than the minimum allowed contribution of  {min}",
    belowMinBond: "Input is less than the minimum surggest bonded of 0.1",
    wrongNominatorAddress: "Wrong Nominator Address",
    wrongTransferAddress: "Wrong Transfer Address",
    inputAddressType: "Please Input {relaychain} Address",
    insufficientBalance:"Insufficient Balance",
    outOfCap: "Out of cap",
    tips:"Tips",
    error: "Error!",
    success: "Success!",
    warning: "Warning!",
    noNeedWithdraw: 'No Need To Withdraw',
    comingSoon: 'Coming Soon',
    clipboard:"	Clipboard",
    copyAddress:"Copied address:  {address}",
    signing: "Signing"
},
  vote:{
    upvote:"Upvote",
    vote:"Upvote post",
    title:"Pay PNUT,and get nutbox.mine's upvote",
    link:"Post link",
    payPnut:"Pay PNUT",
    linkPlaceholder:"Input post link",
    pnutPlaceholder:"Input PNUT amount",
    transfer:"Transfer",
    voteRate:"PNUT - 10% upvote",
  },
  nps: {
    nps: 'Governance',
    pass: 'Passed',
    pending: 'Pending',
    unpass: 'Rejected',
    rolling: 'Voting'
  },
  error: {
    error: 'Error!',
    depositFail: 'Deposit fail',
    withdrawFail: 'Withdraw fail',
    changeDepsitFail: 'Change deposition fail',
    delegateFail: 'Delegate fail',
    changeDelegateFail: 'Change delegation fail',
    approveFail: 'Approve fail',
    accountChanged: 'steem and tron address mismatch',
    delegateerror: 'Delegation Error！',
    tryrefreshpage: 'Error，please refresh page and try again!',
    steemloginerr: 'Steem login failed!',
    needkeychainandtronlink: 'Need to install Steem Keychain and TronLink!',
    needkeychain: 'Please install Steem Keychain',
    needtronlink: 'Please install TronLink',
    insufficientEnerge: 'Not enough energy',
    transferFail: 'Transfer fail',
    unlockKeychain: 'Please unlock Steem Keychain',
    unlockWallet: 'Please unlock tronlink',
    steemLoginFail: 'Steem login fail',
    illegalTronAddress: 'Invalid tron address',
    inputError: 'Input wrong value',
    inputOverflow: 'Input overflow',
    inputOutOfRange: "Please input value between {lowerPnutAmount}-{upperPnutAmount}",
    inputLinkIllegal:"Please input correct link",
    transferFail: "Transfer Fail",
    notEnoughFee: 'Insufficient fee',
    insufficentPnut:"Insufficent PNUT",
    hasVoted:"Your post has been voted by nutbox.mine",
    pleaseRetry: "Please try again"
  },
}
